import React from "react";

const Contact = () => {
  return (
    <div className="page-wrapper">
      {/* Header Main Area */}
      <header className="site-header header-style-1">
        <div className="pbmit-title-bar-wrapper2">
          <div className="container">
            <div className="pbmit-title-bar-content">
              <div className="pbmit-title-bar-content-inner">
                <div className="pbmit-tbar">
                  <div className="pbmit-tbar-inner container">
                    <h1 className="pbmit-tbar-title">Contact Us</h1>
                  </div>
                </div>
                <div className="pbmit-breadcrumb">
                  <div className="pbmit-breadcrumb-inner">
                    <span>
                      <a title="" href="#" className="home">
                        <span> TRACKLINE XR</span>
                      </a>
                    </span>
                    <span className="sep">
                      <i className="pbmit-base-icon-angle-right"></i>
                    </span>
                    <span>
                      <span className="post-root post post-post current-item">
                        Contact Us
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Title Bar End*/}
      </header>
      {/* Header Main Area End Here */}

      {/* Contact Us Content */}
      <div className="page-content">
        {/* Ihbox */}
       <section className="section-xl py-5 bg-light">
  <div className="container">
    <div className="row g-4">
      {/* Mail Box */}
      <article className="col-md-6 col-lg-4 col-xl-3">
        <div className="info-box text-center p-4 bg-white shadow-sm rounded h-100 d-flex flex-column align-items-center">
          <div className="info-icon-circle mb-3 d-flex justify-content-center align-items-center">
            <i className="bi bi-envelope-fill fs-2 text-white"></i>
          </div>
          <div className="info-content flex-grow-1">
            <h5 className="mb-2">Mail Us 24/7</h5>
            <a href="mailto:Info@tracklinexr.com" className="text-decoration-none text-dark">
              admin@tracklinexr.com
            </a>
          </div>
        </div>
      </article>

      {/* Location Box */}
      <article className="col-md-6 col-lg-4 col-xl-3">
        <div className="info-box text-center p-4 bg-white shadow-sm rounded h-100 d-flex flex-column align-items-center">
          <div className="info-icon-circle mb-3 d-flex justify-content-center align-items-center">
            <i className="bi bi-geo-alt-fill fs-2 text-white"></i>
          </div>
          <div className="info-content flex-grow-1">
            <h5 className="mb-2">Our Location</h5>
            
            <p className="mb-0"><strong>USA:</strong> 9522 Majestic Canyon Ln, Houston, TX 77070</p>
            {/* <p className="mb-1"><strong>India:</strong> C-33, Phase 2, Industrial Area S.A.S Nagar, Mohali</p> */}
          </div>
        </div>
      </article>

      {/* Call Box */}
      <article className="col-md-6 col-lg-4 col-xl-3">
        <div className="info-box text-center p-4 bg-white shadow-sm rounded h-100 d-flex flex-column align-items-center">
          <div className="info-icon-circle mb-3 d-flex justify-content-center align-items-center">
            <i className="bi bi-telephone-fill fs-2 text-white"></i>
          </div>
          <div className="info-content flex-grow-1">
            <h5 className="mb-2">Call Us 24/7</h5>
            <p className="mb-0"> 713-275-8786</p>
          </div>
        </div>
      </article>

      {/* Working Days Box */}
      <article className="col-md-6 col-lg-4 col-xl-3">
        <div className="info-box text-center p-4 bg-white shadow-sm rounded h-100 d-flex flex-column align-items-center">
          <div className="info-icon-circle mb-3 d-flex justify-content-center align-items-center">
            <i className="bi bi-calendar-fill fs-2 text-white"></i>
          </div>
          <div className="info-content flex-grow-1">
            <h5 className="mb-2">Office Hours :</h5>
            <p className="mb-1"> 09:00 AM To 06:00 PM (Pacific Standard Time, USA)</p>
            {/* <p className="mb-0">Sat to Sun - Closed</p> */}
          </div>
        </div>
      </article>
    </div>
  </div>
</section>

        {/* Ihbox End */}

        {/* Contact Form */}
        <section>
          <div className="container">
            <div className="row g-0">
              <div className="col-md-12 col-xl-6">
                <div className="contact-us-left-area">
                  <div className="pbmit-heading-subheading animation-style4">
                    <h4 className="pbmit-subtitle">Contact us</h4>
                    <h2 className="pbmit-title">
                      Write us what you want to know
                    </h2>
                    <div className="pbmit-heading-desc">
                      We carefully screen all of our cleaners, so you can rest
                      assured that <br /> your home would receive the absolute
                      highest quality of service providing.
                    </div>
                  </div>
                  <div className="contact-bg-img">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/img.png`} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-xl-6">
                <div className="contact-form-rightbox pbmit-bg-color-white">
                  <div className="pbmit-heading animation-style2">
                    <h2 className="pbmit-title">
                      Send a message to staff
                    </h2>
                  </div>
                  <p>
                    Your email address will not be published. Required fields
                    are marked *
                  </p>
                  <form
                    className="contact-form"
                    method="post"
                    id="contact-form"
                    
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Your Name"
                          name="name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email"
                          name="email"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Your Phone"
                          name="phone"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Subject"
                          name="subject"
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <textarea
                          name="message"
                          cols="40"
                          rows="10"
                          className="form-control"
                          placeholder="Message"
                          required
                        ></textarea>
                      </div>
                      <div className="col-md-12">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            Save my name, email, and website in this browser for
                            the next time I comment.
                          </label>
                        </div>
                      </div>
                    </div>
                    <button className="pbmit-btn submit my-4">
                      <span className="pbmit-button-content-wrapper">
                        <span className="pbmit-button-text">
                          Get Cost Estimate
                        </span>
                      </span>
                      <span className="form-btn-loader d-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 200 100"
                        >
                          <circle
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="15"
                            r="15"
                            cx="40"
                            cy="50"
                          >
                            <animate
                              attributeName="opacity"
                              calcMode="spline"
                              dur="2"
                              values="1;0;1;"
                              keySplines=".5 0 .5 1;.5 0 .5 1"
                              repeatCount="indefinite"
                              begin="-.4"
                            ></animate>
                          </circle>
                          <circle
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="15"
                            r="15"
                            cx="100"
                            cy="50"
                          >
                            <animate
                              attributeName="opacity"
                              calcMode="spline"
                              dur="2"
                              values="1;0;1;"
                              keySplines=".5 0 .5 1;.5 0 .5 1"
                              repeatCount="indefinite"
                              begin="-.2"
                            ></animate>
                          </circle>
                          <circle
                            fill="#fff"
                            stroke="#fff"
                            strokeWidth="15"
                            r="15"
                            cx="160"
                            cy="50"
                          >
                            <animate
                              attributeName="opacity"
                              calcMode="spline"
                              dur="2"
                              values="1;0;1;"
                              keySplines=".5 0 .5 1;.5 0 .5 1"
                              repeatCount="indefinite"
                              begin="0"
                            ></animate>
                          </circle>
                        </svg>
                      </span>
                    </button>
                    <div className="col-md-12 col-lg-12 message-status"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Form End */}

        {/* Client Start */}
        {/* <section className="section-xl border-bottom">
          <div className="container-fluid">
            <div className="row pbmit-element-posts-wrapper">
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-01.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-01.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                </div>
                </div>
              </article>
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-02.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-02.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-03.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                         src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-03.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-04.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                         src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-04.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-05.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                         src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-05.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
              <article className="pbmit-client-style-1 col-md-4 col-lg-3 col-xl-2">
                <div className="pbmit-border-wrapper">
                  <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                    <h4 className="pbmit-hide">Client-01</h4>
                    <div className="pbmit-client-hover-img">
                      <img
                       src={`${process.env.PUBLIC_URL}/assets/images/client/client-global-06.png`}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="pbmit-featured-img-wrapper">
                      <div className="pbmit-featured-wrapper">
                        <img
                        src={`${process.env.PUBLIC_URL}/assets/images/client/client-dark-06.png`}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </section> */}
        {/* Client End */}

        {/* Iframe */}
        <section className="contact-iframe-section">
          <div className="container-fluid p-0">
            <iframe
              src="https://maps.google.com/maps?q=9522+Majestic+Canyon+Ln,+Houston,+TX+77070+USA&t=m&z=15&output=embed&iwloc=near"
  title="9522 Majestic Canyon Ln, Houston, TX 77070, USA"
  aria-label="9522 Majestic Canyon Ln, Houston, TX 77070, USA"
            ></iframe>
          </div>
        </section>
        {/* Iframe End */}
      <section className="accordion-three-bg section-xl">
  <div className="container">
    <div className="row g-0">
      <div className="col-md-0 col-xl-3"></div>
      <div className="col-md-12 col-xl-9">
        <div className="ms-xl-5 ps-xl-4">
          <div className="pbmit-heading-subheading">
            <h2 className="pbmit-title">Frequently Asked Questions</h2>
            <h4>
              At Trackline XR, we know that choosing the right freight partner is
              about more than price — it’s about trust, compliance, and service
              reliability. Below are answers to the most common questions our
              shippers ask us.
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div className="accordion" id="accordionExample1">
      {/* Accordion Item 1 */}
      <div className="accordion-item active" id="headingOne1">
        <h2 className="accordion-header">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne1"
            aria-expanded="true"
            aria-controls="collapseOne1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">01</span>
              Are you fully licensed and compliant as a freight brokerage?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseOne1"
          className="accordion-collapse collapse show"
          aria-labelledby="headingOne1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            <p>
              Yes. We are registered with the FMCSA (Federal Motor Carrier Safety
              Administration) and operate under an active MC authority. We also
              maintain the required $75,000 surety bond (BMC-84) and broker
              liability insurance, ensuring that your shipments are always handled
              legally, ethically, and securely.
            </p>
          </div>
        </div>
      </div>

      {/* Accordion Item 2 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo1"
            aria-expanded="false"
            aria-controls="collapseTwo1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">02</span>
              What types of freight services do you provide?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseTwo1"
          className="accordion-collapse collapse"
          aria-labelledby="headingTwo1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            We manage a complete range of transportation services across the
            U.S., including:
            <ul>
              <li>• Full Truckload (FTL) – Dedicated capacity for large shipments.</li>
              <li>• Less-Than-Truckload (LTL) – Cost-effective option for smaller loads.</li>
              <li>• Drayage & Intermodal – Seamless port and rail container movements.</li>
              <li>
                • Specialized Freight – Temperature-controlled, oversized, or
                high-value cargo.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Accordion Item 3 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingThree1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree1"
            aria-expanded="false"
            aria-controls="collapseThree1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">03</span>
              How do you ensure carriers are reliable and compliant?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseThree1"
          className="accordion-collapse collapse"
          aria-labelledby="headingThree1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            We only partner with vetted carriers who are FMCSA-registered,
            maintain active authority and insurance, and meet strict safety
            standards. Our compliance team continuously monitors carrier
            performance, so your freight is moved by trusted professionals every
            time.
          </div>
        </div>
      </div>

      {/* Accordion Item 4 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFour1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFour1"
            aria-expanded="false"
            aria-controls="collapseFour1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">04</span>
              How do you protect my shipment financially?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseFour1"
          className="accordion-collapse collapse"
          aria-labelledby="headingFour1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            Your freight is safeguarded by multiple layers of protection:
            <ul>
              <li>• Carrier liability insurance (standard for all shipments).</li>
              <li>
                • Our active MC authority, $75,000 surety bond, and broker
                liability insurance.
              </li>
            </ul>
            This means your cargo — and your payments — are always protected.
          </div>
        </div>
      </div>

      {/* Accordion Item 5 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFive1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFive1"
            aria-expanded="false"
            aria-controls="collapseFive1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">05</span>
              How are shipping rates determined?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseFive1"
          className="accordion-collapse collapse"
          aria-labelledby="headingFive1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            Rates depend on shipment size and weight, pickup and delivery
            locations, service type (FTL, LTL, intermodal), and current market
            conditions (fuel, capacity). We leverage our carrier network and
            real-time market intelligence to secure the most competitive and
            transparent rates for your business.
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      </div>
    </div>
  );
};

export default Contact;